export default __webpack_public_path__ + "navigation-examples-beta-query-parameters-thumbnail-480-dfb6c0a902dec5a2856e8fa8d6212f4a.png";